import React from "react";
import DOMPurify from "dompurify";
import styles from './styles.module.scss';

export const IntegrationSectionDetail = ({ content, note }) => {
  return (
    <div className={styles.detail}>
      <ol>
        {content.map((item, index) => (
          <li key={index}><span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item, {ADD_ATTR: ['target']}) }}></span></li>
        ))}
      </ol>
      <div className={styles.note}>
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note)}}></span>
      </div>
    </div>
  );
};
